import React from "react";
import Markdown from "markdown-to-jsx";

function AnswerTable({ children }: { children?: React.ReactNode }) {
  return (
    <div className="audience-answer-table" role="region" aria-label="Answer table" tabIndex={0}>
      <table>{children}</table>
    </div>
  );
}

function AnswerLink({ href, children }: { href?: string; children?: React.ReactNode }) {
  // Answers contain untrusted source text. Only explicit web URLs are links.
  if (!href || !/^https?:\/\//i.test(href)) return <>{children}</>;
  return <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
}

export default function AudienceChatAnswer({ text }: { text: string }) {
  return (
    <Markdown
      className="audience-chat-answer"
      options={{
        forceBlock: true,
        forceWrapper: true,
        disableParsingRawHTML: true,
        disableAutoLink: true,
        overrides: {
          table: AnswerTable,
          a: AnswerLink,
          // A chat answer should never fetch arbitrary remote images.
          img: () => null,
        },
      }}
    >
      {text}
    </Markdown>
  );
}
